// extracted by mini-css-extract-plugin
export default {"container":"PaginationV2_container__1-hCQ","list":"PaginationV2_list__SxiKu"};